import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
let searchData = {
    Name: '',
    PageNumber: 1,
    PageSize: 25
}
export const getExceptionList = (item) => {
    let url = `${API.Exception}?Name=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getExceptionListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getExceptionListFailure",
                    error: "ERROR"
                })
            })
    }
}
export const postExceptionList = (data) => {
    let url = `${API.Exception}`;
    return dispatch => {
        axios.post(url, data)
            .then((response) => {
                if (response.data) {
                    toast.success('Added Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    dispatch(getExceptionList(searchData));
                }
                dispatch({
                    type: "postExceptionSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postExceptionFailure",
                    error: "ERROR"
                })
            })
    }
}
export const putExceptionList = (data) => {
    let url = `${API.Exception}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                if (response.data) {
                    toast.success('Updated Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    dispatch(getExceptionList(searchData));
                }
                dispatch({
                    type: "updateExceptionSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "updateExceptionFailure",
                    error: "ERROR"
                })
            })
    }
}
export const deleteExceptionList = (data) => {
    let url = `${API.Exception}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                if (response.data) {
                    toast.success('Deleted Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    dispatch(getExceptionList(searchData));
                }
                dispatch({
                    type: "deleteExceptionSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "deleteExceptionFailure",
                    error: "ERROR"
                })
            })
    }
}

